import { useEffect } from 'react';
import { loadWalletInfoAsync } from '../../../data-layer/cpa/actions';
import { selectWalletInfo } from '../../../data-layer/cpa/selectors';
import { CpaStatus } from '../../../data-layer/cpa/types';
import { showNotificationAsync } from '../../../data-layer/notifications/actions';
import { useDispatch } from '../../../data-layer/useDispatch';
import { useSelector } from '../../../data-layer/useSelector';
import { CpaRewardContent } from '../../../ui/users/CpaRewardContent/CpaRewardContent';
import { canShowCpa } from '../../../utils/accessService';
import { useCurrentUser } from '../useCurrentUser';
import { HIDE_BUTTON_STATUSES, WALLET_RELEVANT_STATUSES } from './constants';
import type { CpaContainerProps } from './types';

export const CpaContainer = ({ business }: CpaContainerProps) => {
    const dispatch = useDispatch();
    const walletInfo = useSelector(selectWalletInfo);

    const currentUser = useCurrentUser();
    const cpaStatus = currentUser?.cpaStatus;

    const cpaEnabled = canShowCpa(currentUser, business);

    const shouldLoadWalletInfo =
        cpaEnabled && cpaStatus && WALLET_RELEVANT_STATUSES.includes(cpaStatus) && !walletInfo;

    useEffect(() => {
        if (shouldLoadWalletInfo) {
            dispatch(loadWalletInfoAsync());
        }
    }, [dispatch, shouldLoadWalletInfo]);

    useEffect(() => {
        if (cpaEnabled && cpaStatus === CpaStatus.UNKNOWN) {
            dispatch(showNotificationAsync('Не удалось загрузить данные кошелька'));
        }
    }, [dispatch, cpaStatus, cpaEnabled]);

    if (!cpaEnabled || !cpaStatus || HIDE_BUTTON_STATUSES.includes(cpaStatus)) {
        return null;
    }

    return <CpaRewardContent />;
};
